// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchResult.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var SearchGridResult = require('./Izenda.SearchGridResult');

  var SearchResult = function (props) {
    
    var store = props.store;
    var searchResult = store.searchResult;
    var isEmpty = searchResult.isEmpty;
    var systemSearchResult = searchResult.systemSearchResult;
    var tenantSearchResult = searchResult.tenantSearchResult;
    var localization = props.localization;

    return (
        <div className="izenda-SearchResult">
          <div className="izenda-SearchResult-Header u_paddingAll">
            <span className="u_textBold">{localization.getText("SEARCH_RESULT_LABEL_SEARCH_RESULT")}</span>
          </div>
          { !isEmpty
            ? <div className="izenda-SearchResult-Content" style={{height: 500}}>
                <ScrollBox>
                  {!systemSearchResult.isEmpty && <SearchGridResult  data={systemSearchResult} name="System" store={store} />}
                  {renderTenantSchedules(tenantSearchResult)}
                </ScrollBox>
              </div>
            : <div className="u_paddingAll">{localization.getText("COMMON_MESSAGES_NO_RECORD_FOUND")}</div>
          }
        </div>
    );

    /**
     * Render tenant's grid schedules
     * @returns {Array}
     */
    function renderTenantSchedules (tenantSearchResult) {
      var keys = tenantSearchResult.keys();
      return keys.map(function (key, index) {
        if (!tenantSearchResult.get(key).isEmpty) {
          return <SearchGridResult key={index} data={tenantSearchResult.get(key)} name={key} store={store} />
        }
      });
    }
  };

  module.exports = connect()(SearchResult);

}());


// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Scheduling/Izenda.SeachResult.jsx